import exportApi from '../services/export-api';
import { ExportSquare } from 'iconsax-react';
import { TableActionIconButton } from '@src/design-system/molecules/ticlick-table/actions';
import type { ValueOf } from '../types/utilities';
import type { EXPORT_TYPES } from '../types/export';

const ExportEntity = ({
  entity,
  view,
}: {
  entity: ValueOf<typeof EXPORT_TYPES>;
  view?: number;
}) => {
  const { mutateAsync: exportEntity, isPending } = exportApi.useCreate();

  return (
    <TableActionIconButton
      label='Export'
      isLoading={isPending}
      className='border-pale-border'
      icon={
        <ExportSquare
          className='text-secondary-1000'
          variant='TwoTone'
        />
      }
      onClick={() =>
        exportEntity({
          export_type: entity,
          view: view,
        })
      }
    />
  );
};

export default ExportEntity;
